import Dashboard2 from './Dashboard';
export default Dashboard2;
